site.mMenu = {
	selector: null,

	init: function() {
		var $menu = $('> .mmLevel1', '#mainmenu');
		if ($menu.length === 0) return false;

		var $html = $('html'),
			$body = $('body'),
			$mm = $('<div id="mMenu" role="navigation"></div>'),
			$mMenu = $menu.clone().removeAttr('id'),
			backLabel = ($html.attr('lang') === 'is') ? 'Til baka' : 'Back',
			nextLabel = ($html.attr('lang') === 'is') ? 'Áfram' : 'Next';

		$('ul',$mMenu).removeAttr('id');
		$mm.append($mMenu);
		$body.append($mm);

		var $navbar = '<a href="#mm-1" class="home"><span>' + backLabel + '</span></a>';

		site.mMenu.selector = $('#mMenu');

		site.mMenu.selector.mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [
				{
					position: "top",
					content: $navbar,
				}
			]
		},{
			// configuration
			classNames: {
				selected:"active"
			},
			offCanvas: {
				menuInjectMethod: "append"
			}
		});

		var API = site.mMenu.selector.data( "mmenu" );

		$("#mainmenuToggle").click(function() {
			API.close();
		});

		$('.mm-page.mm-slideout').removeClass('mm-slideout');

		$('.mm-navbar', '.mm-panel:first-of-type').remove();

		$('.mm-next', site.mMenu.selector).attr('aria-label', nextLabel);
		$('.mm-btn.mm-prev', site.mMenu.selector).attr('aria-label', backLabel);

		var $div = $('.mm-panel:first-child', '.mm-panels');
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === "class") {
					var attributeValue = $(mutation.target).prop(mutation.attributeName);
					//if ($body.hasClass('')
					if (attributeValue.indexOf('mm-subopened') > 0) {
						$body.addClass('mm-subopened');
					}
					else {
						$body.removeClass('mm-subopened');
					}

				}
			});
		});
		observer.observe($div[0], {
			attributes: true
		});

		if ($div.hasClass('mm-subopened')) {
			$body.addClass('mm-subopened');
		}

		site.mMenu.appendQn();
		site.mMenu.appendSearch();
		site.mMenu.appendFooter();
	},

	appendQn: function() {
		var $mQn = $('#qn-5').clone().attr('id', 'mQn');
		$('#mm-1').append($mQn);

		// For english division
		var $mQn2 = $('#qn-12').clone().attr('id', 'mQn');
		$('#mm-1').append($mQn2);
	},

	appendSearch: function() {
		var $mSearch = $('#searchForm').clone(),
			$level1 = $('.mmLevel1', site.mMenu.selector);

		$mSearch.removeAttr('id');
		$('> div', $mSearch).removeAttr('id');
		$('#q', $mSearch).attr('id', 'mmQ');
		$('label', $mSearch).attr('for', 'mmQ');
		$('#searchSubmit', $mSearch).removeAttr('id');

		$('#mm-1').append('<div class="box_search"></div>');
		$('.box_search', site.mMenu.selector).append($mSearch);
	},

	appendFooter: function() {
		var $footer = $('#footerInfo').clone().removeAttr('id').attr('class', 'footer');
		$('#mm-1').append($footer);
	}
};

site.inits.push('site.mMenu.init()');
